// extracted by mini-css-extract-plugin
export default {"action-buttons":"ActionButtons_action-buttons__yOzAk","right-buttons":"ActionButtons_right-buttons__db7q5"};